<script>
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { Table } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import { navigate } from "svelte-routing";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";

	export let data = {
		data: [],
	};
	export let fetchFleetPartnerData;
	export let handleSort;

	let sort = {
		desc: "desc",
		column: "",
	};

	function toggleSort(column) {
		if (sort.column === column) {
			sort.desc = sort.desc === "desc" ? "asc" : "desc";
		} else {
			sort.column = column;
			sort.desc = "asc";
		}
		handleSort(column, sort.desc);
	}
</script>

<LoaderContainer>
	{#if data?.data.length}
		<Table responsive hover>
			<thead>
				<tr>
					<th>
						<span class="sort-column">
							Fleet partner
							<button
								type="button"
								style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
								on:click={() => toggleSort("carAssetOwnerName")}
								>{#if sort.desc === "asc" && sort.column === "carAssetOwnerName"}
									<img
										src="/assets/icon-sort-up-thin.svg"
										alt="icon-sort-up"
									/>
								{:else}
									<img
										src="/assets/icon-sort-down-thin.svg"
										alt="icon-sort-down"
									/>
								{/if}
							</button>
						</span>
					</th>
					<th>
						<span class="sort-column">
							Fuel type
							<button
								type="button"
								style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
								on:click={() => toggleSort("fuelTypeName")}
								>{#if sort.desc === "asc" && sort.column === "fuelTypeName"}
									<img
										src="/assets/icon-sort-up-thin.svg"
										alt="icon-sort-up"
									/>
								{:else}
									<img
										src="/assets/icon-sort-down-thin.svg"
										alt="icon-sort-down"
									/>
								{/if}
							</button>
						</span>
					</th>
					<th>
						<span class="sort-column">
							Duration
							<button
								type="button"
								style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
								on:click={() => toggleSort("DurationDays")}
								>{#if sort.desc == "asc" && sort.column == "DurationDays"}
									<img
										src="/assets/icon-sort-up-thin.svg"
										alt="icon-sort-up"
									/>
								{:else}
									<img
										src="/assets/icon-sort-down-thin.svg"
										alt="icon-sort-down"
									/>
								{/if}
							</button>
						</span>
					</th>
					<th>
						<span class="sort-column">
							Mileage
							<button
								type="button"
								style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
								on:click={() => toggleSort("MileageKm")}
								>{#if sort.desc == "asc" && sort.column == "MileageKm"}
									<img
										src="/assets/icon-sort-up-thin.svg"
										alt="icon-sort-up"
									/>
								{:else}
									<img
										src="/assets/icon-sort-down-thin.svg"
										alt="icon-sort-down"
									/>
								{/if}
							</button>
						</span>
					</th>
				</tr>
			</thead>
			<tbody>
				{#each data.data as { ruleId, carAssetOwnerName, fuelTypeName, durationInDays, mileageInKm }}
					<tr
						class="clickable"
						on:click={() =>
							navigate(
								"/servicing/manage-rules/edit-rule/" + ruleId
							)}
					>
						<td>
							<span>{carAssetOwnerName}</span>
						</td>
						<td>
							{fuelTypeName ? fuelTypeName : "-"}
						</td>
						<td>
							{new Intl.NumberFormat("en-US").format(
								durationInDays
							)} days
						</td>
						<td>
							{new Intl.NumberFormat("en-US").format(
								mileageInKm
							) + " km"}
						</td>
					</tr>
				{/each}
			</tbody>
		</Table>
		<Pagination totalRecord={data.totalCount} />
	{:else}
		<div
			class="d-flex flex-column align-items-center justify-content-center"
			style="margin-top: 5em;"
		>
			<div>
				<h5>No rules yet</h5>
			</div>
			<div>
				<p>Rules will show up here once you create it.</p>
			</div>
			<div>
				<CustomButton
					buttonText="Add rule"
					on:click={() =>
						navigate("/servicing/manage-rules/add-rule")}
				/>
			</div>
		</div>
	{/if}
</LoaderContainer>

<style>
	.sort-column {
		display: flex;
		justify-content: space-between;
	}

	.clickable {
		cursor: pointer;
	}
</style>
